import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyEvaluation, HttpResponse } from "@/types";

export const candidacyEvaluationsQueryKey = (
  companyId: string | undefined,
  jobId: string | undefined,
  candidacyId: string,
) => ["candidacy-evaluations", companyId, jobId, candidacyId] as const;

// The legacy evaluations blob, fetched only by the legacy evaluations tab so
// the candidacy-info payload stays slim for every other sheet.
export const useGetCandidacyEvaluations = ({
  candidacyId,
}: {
  candidacyId: string;
}) => {
  const companyId = useCurrentCompanyId();
  const jobId = useCurrentJobId();

  return useQuery({
    queryKey: candidacyEvaluationsQueryKey(companyId, jobId, candidacyId),
    queryFn: async () => {
      const path = `companies/${companyId}/jobs/${jobId}/candidacies/${candidacyId}/evaluations`;
      const response = await guacHttpClient.get<
        CandidacyEvaluation[] | null,
        HttpResponse<CandidacyEvaluation[] | null>
      >(path);

      return response.data;
    },
    enabled: !!candidacyId,
  });
};
